import { render, staticRenderFns } from "./CandidatesPanel.vue?vue&type=template&id=28cfec55"
import script from "./CandidatesPanel.vue?vue&type=script&lang=js"
export * from "./CandidatesPanel.vue?vue&type=script&lang=js"
import style0 from "./CandidatesPanel.vue?vue&type=style&index=0&id=28cfec55&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports